var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5597 23.7769C29.5597 23.7769 23.5862 33.4626 18.6887 33.4626C10.1225 33.4626 18.1056 15.0107 24.3533 15.0107C28.7128 15.0107 29.5597 23.7769 29.5597 23.7769Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6578 35.9579C34.9561 37.7687 32.8558 39.1582 30.5235 40.0162C28.1912 40.8742 25.6911 41.1771 23.2213 40.901C20.7516 40.6248 18.3801 39.7771 16.295 38.4252C14.21 37.0732 12.4686 35.2541 11.209 33.1122C12.6251 35.0382 15.027 36.3223 18.4424 36.3223C26.8559 36.3223 31.6319 29.7841 31.6319 29.7841C31.6319 29.7841 32.045 34.9515 36.6474 35.9579H36.6578Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1778 17.5962C40.4371 20.0022 41.0625 22.6894 40.9951 25.4041C40.9277 28.1188 40.1697 30.7716 38.7925 33.1122C37.7033 32.5012 36.898 31.4866 36.5503 30.2873L34.7246 24.818L39.1778 17.5962Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0025 9.0139C29.0148 9.01123 32.881 10.519 35.8318 13.2373L32.8017 18.1271C31.7049 15.2744 29.4765 12.4183 25.1414 12.4183C16.2627 12.4183 9.68185 22.1111 9.68185 28.1877C9.67989 28.9735 9.78023 29.7563 9.98034 30.5163C9.09247 28.098 8.80164 25.5012 9.13257 22.9465C9.46351 20.3918 10.4064 17.9547 11.8812 15.8424C13.3559 13.7302 15.3189 12.0051 17.6033 10.8138C19.8878 9.62254 22.4261 9.00031 25.0025 9V9.0139Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default_avatar.5caf5370be670b9585f84fab71915e90.svg";
export { ForwardRef as ReactComponent };